import { render, staticRenderFns } from "./Karin-resolve.vue?vue&type=template&id=d778e12a"
import script from "./Karin-resolve.vue?vue&type=script&lang=js"
export * from "./Karin-resolve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports